import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import UserMenu from "./UserMenu";
// import { LogIn, UserRoundPlus } from "lucide-react";
import { useSetAtom, useAtom } from "jotai";
import {
  addOnsAtom,
  balanceAtom,
  challengeAtom,
  feeAtom,
  navbarHeightAtom,
  platformAtom,
  profileAtom,
  userAtom,
} from "@/store/atoms";
// import LanguageSelectButton from "./LanguageSelectButton";
import {
  FaBars,
} from "react-icons/fa6";
import { env } from "@/config/env";
import { profile } from "@/api/endpoints/profile";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import Logo from "./common/Logo";
// import GeneralButtonWithCss from "./landing/GeneralButtonWithCss";

export default function Navbar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleLogo = () => {
    navigate("/");
  };
  const [token, setToken] = useState<string>("");
  const setAccountBalance = useSetAtom(balanceAtom);
  const [profileGlobal, setProfileGlobal] = useAtom(profileAtom);
  const setPlatform = useSetAtom(platformAtom);
  const setFee = useSetAtom(feeAtom);
  const setChallenge = useSetAtom(challengeAtom);
  const setAddOns = useSetAtom(addOnsAtom);
  const [userInfoGlobal, setUserInfoGlobal] = useAtom(userAtom);
  const [user] = useAtom(userAtom);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);

    if (hambergerRef.current) {
      const rect = hambergerRef.current.getBoundingClientRect();
      let dropdownLeft = rect.left;
      const dropdownWidth = 120;
      const viewportWidth = window.innerWidth;

      if (dropdownLeft + viewportWidth > viewportWidth) {
        dropdownLeft = viewportWidth - dropdownWidth - 10;
      }

      setDropdownPosition({
        top: rect.bottom + window.scrollY,
        left: dropdownLeft,
      });

    }
  };

  useEffect(() => {
    // Token is used only for UI gating here. User info comes from global session bootstrap in App.
    const userToken = localStorage.getItem("token") || "";
    const accountBalance = localStorage.getItem("balance") || "";
    const platform = localStorage.getItem("platform") || "mt4";
    const fee = localStorage.getItem("fee") || "";
    const challenge = localStorage.getItem("challenge") || "";
    const addOns = localStorage.getItem("addOns") || "";

    if (userToken) {
      setToken(userToken);
    }

    if (accountBalance) {
      setAccountBalance(Number(accountBalance));
    }
    if (platform) {
      setPlatform(platform);
    }
    if (fee) {
      setFee(Number(fee));
    }
    if (challenge) {
      setChallenge(challenge);
    }
    if (addOns) {
      setAddOns(JSON.parse(addOns));
    }

  }, []);

  // calculation of the Navbar height
  const navbarRef = useRef<HTMLElement>(null);
  const setNavbarHeight = useSetAtom(navbarHeightAtom);

  useEffect(() => {
    if (navbarRef.current) {
      const height = navbarRef.current.offsetHeight;
      setNavbarHeight(height);
    }
  }, [setNavbarHeight]);

  useEffect(() => {
    if (userInfoGlobal?.email) {
      profile
        .getProfile(userInfoGlobal.email)
        .then((res) => {

          // Handle the correct response structure: res.data.profile
          const profileData = res.data?.profile || {};

          setProfileGlobal((prev) => ({
            ...prev,
            ...profileData,
            email: userInfoGlobal.email,
            userName: profileData?.name || profileData?.firstName || '',
            firstName: profileData?.firstName || '',
            lastName: profileData?.lastName || '',
          }));

          // Update userAtom with picture if it exists
          if (profileData?.picture && userInfoGlobal) {
            setUserInfoGlobal({
              ...userInfoGlobal,
              picture: profileData.picture,
            });
          }
        })
        .catch((error) => {
          // Don't show error for 404 (profile doesn't exist yet)
          if (error?.response?.status !== 404) {
            console.error("Profile fetch error:", error);
          }
        });
    }
  }, [userInfoGlobal?.email]);

  const dropdownRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getFirstLetterUppercase = (str: string) => {
    if (!str || str.length === 0) return "U";
    return str.charAt(0).toUpperCase();
  };

  const getUserInitial = () => {
    // Try to get initial from profile data first
    if (profileGlobal?.firstName) {
      return getFirstLetterUppercase(profileGlobal.firstName);
    }
    if (profileGlobal?.name) {
      return getFirstLetterUppercase(profileGlobal.name);
    }
    // Fallback to email if no profile name available
    if (userInfoGlobal?.email) {
      return getFirstLetterUppercase(userInfoGlobal.email);
    }
    return "U";
  };
  const handleSignin = () => {
    navigate("/login");
  };
  

  const handleDashboardButton = () => {
    if (user?.email) {
      // Always navigate to user dashboard for all logged-in users (including admins)
      navigate("/user/dashboard");
    } else {
      toast.warn("Please login first.");
      navigate("/login");
    }
  };
  const hambergerRef = useRef<HTMLButtonElement>(null);
  const [_, setDropdownPosition] = useState({ top: 0, left: 0 });

  const navItemClassName = ({ isActive }: { isActive: boolean }) =>
    [
      "hover:text-[#DBD633] transition-colors duration-300",
      "text-base xl:text-lg  font-normal",
      "px-0 min-[1540px]:px-4",
      isActive ? "text-[#DBD633]" : "",
    ].join(" ");

  const mobileNavItemClassName = ({ isActive }: { isActive: boolean }) =>
    [
      "hover:text-[#DBD633] transition-colors duration-300",
      "lg:text-base  font-normal 2k:px-4",
      isActive ? "text-[#DBD633]" : "",
    ].join(" ");

  return (
    <nav
      className=" px-4 xl:px-0"
      ref={navbarRef}
    >


      <div className=" w-full relative backdrop-blur-sm border border-white/10 bg-[#ffffff]/10 max-w-[1240px] mx-auto text-white   z-50 py-3  2k:py-3 mt-3 px-3.5 rounded-2xl">
        <div className="flex items-center justify-between w-full">
          <div className="flex w-fit justify-center items-center">
            <div className="h-auto mr-0 lg:mr-0 2k:mr-8" onClick={handleLogo}>
              <Logo />
            </div>

          </div>

          {/* Desktop Centered Menu */}
          <div className="hidden lg:flex lg:justify-center font-nexa">
            <ul
              className="flex flex-row w-full xl:w-auto justify-center space-x-3 xl:space-x-5"
              id="navMenu"
            >
              <li>
                <NavLink
                  to="/"
                  end
                  className={navItemClassName}
                >
                  {t("Home")}
                </NavLink>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => handleDashboardButton()}
                  className={[
                    "hover:text-[#DBD633] transition-colors duration-300",
                    "text-base xl:text-lg font-normal px-0 min-[1540px]:px-4",
                    location.pathname.startsWith("/user/dashboard")
                      ? "text-[#DBD633]"
                      : "",
                  ].join(" ")}
                >
                  {t("Dashboard")}
                </button>
              </li>
              <li>
                <NavLink
                  to="/pricing"
                  className={navItemClassName}
                >
                  {t("Pricing")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact-us"
                  className={navItemClassName}
                >
                  {t("Contact")}
                </NavLink>
              </li>

              <li>
                <NavLink
                  to="/about-us"
                  className={navItemClassName}
                >
                  {t("About")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/faqs"
                  className={navItemClassName}
                >
                  {t("FAQs")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/programs"
                  className={navItemClassName}
                >
                  {t("Programs")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="https://urfx.io/blogs/"
                  
                  className={navItemClassName}
                >
                  {t("Blog")}
                </NavLink>
              </li>
              {/* <li className="btn-gradient-left px-2 rounded-md hover:!none">
                <NavLink
                  to="/velocity"
                  
                  className={navItemClassName}
                >
                  {t("Velocity")}
                </NavLink>
              </li> */}

            </ul>
          </div>

          <div className="flex items-center space-x-4 2k:space-x-8">
            {/* Hamburger Menu for Mobile */}
            <div className="lg:hidden flex items-center gap-4">

              <button
                onClick={toggleDropdown}
                className="text-2xl focus:outline-none 2k:text-4xl"
                ref={hambergerRef}
              >
                {isDropdownOpen ? <FaTimes /> : <FaBars />}
              </button>
            </div>



            {token !== "" ? (
              <button
                onClick={() => setIsMenuOpen(true)}
                className="flex items-center space-x-2 p-1.5 text-gray-400 
                       hover:text-white bg-transparent rounded-full 
                       transition-all duration-300 2k:p-4 2k:text-2xl"
              >
                {userInfoGlobal?.picture ? (
                  <img
                    src={`${userInfoGlobal.picture.includes("uploads")
                        ? env.AVATAR_URL + userInfoGlobal.picture
                        : userInfoGlobal.picture
                      }`}
                    alt="user avatar"
                    referrerPolicy="no-referrer"
                    className="w-11 h-11 rounded-full object-cover 2k:w-[70px] 2k:h-[70px]"
                  />
                ) : (
                  <div className="w-11 h-11 text-white  rounded-full  flex justify-center items-center text-xl font-semibold bg-gray-800 2k:w-[70px] 2k:h-[70px] 2k:text-2xl">
                    {getUserInitial()}
                  </div>
                )}
              </button>
            ) : (
              <>
                <div className="lg:flex justify-center items-center gap-4 hidden 2k:gap-8 min-w-[264px]">
                  <div className="w-full h-full">
                    <button
                      onClick={handleSignin}
                      className="btn-register !backdrop-blur-xl bg-white/5 text-lg font-bold py-2 px-3 md:px-6 rounded-[10px]"
                    // bgClassName="dark:bg-[#1A1A1A] dark:bg-none bg-gradient-to-r from-[#7DDEE9] via-[#BBE0A5] to-[#E4E389]"
                    >
                      {t("Login")}
                    </button>
                  </div>

                  <div className="w-full h-full ">
                    <a
                      href="https://t.me/urfxofficial"
                      target="_blank"
                      className="btn-gradient-left text-lg font-bold py-2 px-3 md:px-6 rounded-[10px] w-max"
                    // bgClassName="dark:bg-[#1A1A1A] dark:bg-none bg-gradient-to-r from-[#7DDEE9] via-[#BBE0A5] to-[#E4E389]"
                    >
                      {t("Talk to Sales")}
                    </a>
                  </div>
                </div>
                <div className="flex justify-center items-center gap-4 lg:hidden"></div>
              </>
            )}
          </div>
        </div>

        {token !== "" && (
          <UserMenu
            isOpen={isMenuOpen}
            email={userInfoGlobal?.email || ""}
            picture={
              userInfoGlobal?.picture
                ? userInfoGlobal.picture.includes("uploads")
                  ? env.AVATAR_URL + userInfoGlobal.picture
                  : userInfoGlobal.picture
                : ""
            }
            onClose={() => setIsMenuOpen(false)}
          />
        )}



        {/* Mobile Tray Menu */}
        <ul
          ref={dropdownRef}
          className={`
          absolute top-[100%] left-0 w-full z-50 flex flex-col bg-black/90 backdrop-blur-sm text-white rounded-xl text-center p-6 space-y-4 animate-slideDown transition-all duration-300 
          ${isDropdownOpen ? "translate-y-0" : "translate-y-[-150%]"}
        `}
          id="navMenu"
        >
          <li>
            <NavLink
              to="/"
              onClick={() => setIsDropdownOpen(false)}
              end
              className={mobileNavItemClassName}
            >
              {t("Home")}
            </NavLink>
          </li>
          <li>
            <button
              type="button"
              onClick={() => { handleDashboardButton(); setIsDropdownOpen(false); }}
              className={[
                "hover:text-[#DBD633] transition-colors duration-300",
                "lg:text-base font-normal 2k:px-4",
                location.pathname.startsWith("/user/dashboard")
                  ? "text-[#DBD633]"
                  : "",
              ].join(" ")}
            >
              {t("Dashboard")}
            </button>
          </li>
          <li>
            <NavLink
              to="/pricing"
              onClick={() => setIsDropdownOpen(false)}
              className={mobileNavItemClassName}
            >
              {t("Pricing")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact-us"
              onClick={() => setIsDropdownOpen(false)}
              className={mobileNavItemClassName}
            >
              {t("Contact")}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/about-us"
              onClick={() => setIsDropdownOpen(false)}
              className={mobileNavItemClassName}
            >
              {t("About")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/faqs"
              onClick={() => setIsDropdownOpen(false)}
              className={mobileNavItemClassName}
            >
              {t("FAQs")}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/programs"
              onClick={() => setIsDropdownOpen(false)}
              className={mobileNavItemClassName}
            >
              {t("Programs")}
            </NavLink>
          </li>

          <li>
            <NavLink
              to="https://urfx.io/blogs/"
              className={navItemClassName}
            >
              {t("Blog")}
            </NavLink>
          </li>
          {/* <li className="btn-gradient-left !w-max mx-auto px-2 rounded-md hover:!none">
                <NavLink
                  to="/velocity"
                  
                  className={navItemClassName}
                >
                  {t("Velocity")}
                </NavLink>
              </li> */}

          <div className="flex justify-center items-center gap-4 w-full pt-10"
          >
            {token === "" && (
              <li className={`${isDropdownOpen ? "" : "hidden"} `}>
                <Link
                  to="login"
                  onClick={() => setIsDropdownOpen(false)}
                  className="btn-register !backdrop-blur-xl bg-white/5 text-lg font-bold py-2 px-3 md:px-6 rounded-[10px]"
                >
                  {t("Login")}
                </Link>
              </li>
            )}

            {token === "" && (
              <li className={`${isDropdownOpen ? "" : "hidden"} `}>
                <Link
                  to="https://t.me/urfxofficial"
                  target="_blank"
                  className="btn-gradient-left text-lg font-bold py-2 px-3 md:px-6 rounded-[10px] w-max"

                >
                  {t("Talk To Sales")}
                </Link>
              </li>
            )}
          </div>


        </ul>
      </div>
    </nav>
  );
}
